import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const savingsJourneyRoutes = [
  {
    id: 'savings-transfer-in',
    trackingName: 'Savings Transfer In',
    path: 'web/view/savings/transfer-cash/to-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferIn,
    }),
  },
  {
    id: 'savings-transfer-in-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'web/view/savings/transfer-cash/to-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferInFromGoal,
    }),
  },
  {
    id: 'savings-transfer-out',
    trackingName: 'Savings Transfer Out',
    path: 'web/view/savings/transfer-cash/from-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferOut,
    }),
  },
  {
    id: 'savings-transfer-out-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'web/view/savings/transfer-cash/from-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferOutFromGoal,
    }),
  },
  {
    id: 'savings-folder-default',
    trackingName: 'Default Savings Folder',
    path: 'web/view/savings/folder/default',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsFolder')).JourneySavingsDefaultFolder,
    }),
  },
  {
    id: 'savings-folder-goal',
    trackingName: 'Default Savings Folder Goal',
    path: 'dl/view/savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsFolder')).JourneySavingsGoalFolder,
    }),
  },
  {
    id: 'savings-activity',
    trackingName: 'Savings Activity',
    path: 'web/view/savings/activity',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsActivity')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-activity-filtered',
    trackingName: 'Savings Activity Filtered',
    path: 'web/view/savings/activity/:subToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsActivity')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-interest',
    trackingName: 'Savings Interest',
    path: 'web/view/savings/interest',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsInterest')).JourneySavingsInterest,
    }),
  },
] as const satisfies JourneyRoute[]
